import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CitationService, WkKeywordService } from '../../../services';
import {
  getDefinitionEditor,
  getKeywordEditor,
} from '../../../store/selectors/app.custom-selectors';
import { AppStore } from '../../../store/states';
import { CKEditorComponent } from '../../ckeditor';

@Component({
  selector: 'wk-keyword-and-definition-dialog',
  templateUrl: './keyword-and-definition.dialog.html',
  styleUrls: ['./keyword-and-definition.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkAddKeywordAndDefinitionComponent implements OnInit {
  private keywordEditorData: string;
  private definitionEditorData: string;
  public keywordEditorString: string;
  public definitionEditorString: string;
  public isAddDisable = false;
  private keywordEditor: CKEditorComponent;
  public isEditKeyword = false;
  private readonly _onDestroy$ = new Subject<void>();
  constructor(
    private readonly dialogRef: MatDialogRef<WkAddKeywordAndDefinitionComponent>,
    private readonly citationService: CitationService,
    private readonly store: Store<AppStore>,
    @Inject(MAT_DIALOG_DATA) data: { editKeyword: boolean },
    private readonly wkKeywordService: WkKeywordService
  ) {
    this.isEditKeyword = Boolean(data?.editKeyword);
  }

  ngOnInit(): void {
    combineLatest([
      this.store.select(getKeywordEditor),
      this.store.select(getDefinitionEditor),
    ]).subscribe((value: [string, string]) => {
      this.keywordEditorData = value[0];
      this.definitionEditorData = value[1];
      this.isAddDisable = !this.keywordEditorData || !this.definitionEditorData;
    });
    this.wkKeywordService
      .getKeywordEditorInstance()
      .pipe(takeUntil(this._onDestroy$))
      .subscribe((data: CKEditorComponent | undefined) => {
        data && (this.keywordEditor = data);
      });
    // This will set data in mini editor for keyword.
    this.keywordEditorData = `${this.keywordEditorString}`;
    // This will set data in mini editor for definition.
    this.definitionEditorData = this.definitionEditorString
      ? `${this.definitionEditorString}`
      : '';
  }

  public setSelection(insertKeyword: string) {
    this.keywordEditorString = this.removePropertyFromSelection(insertKeyword);
  }

  removePropertyFromSelection(insertKeyword: string): string {
    const parser = new DOMParser();
    const tempEditorContent = parser.parseFromString(
      insertKeyword,
      'text/html'
    );

    const elements = tempEditorContent.querySelectorAll('*[style]');
    Array.from(elements).forEach((elem: HTMLElement) => {
      elem.style.color = null;
      elem.style.backgroundColor = null;
      elem.style.fontSize = null;
      elem.style.fontFamily = null;
    });
    return tempEditorContent.body.innerHTML;
  }

  closeDialog(): void {
    this.wkKeywordService.closeDefinitionEditor.emit(true);
    this.citationService.switchTab();
    this.dialogRef.close();
  }

  onAddKeyTermAndDefinition() {
    this.wkKeywordService.closeDefinitionEditor.emit(true);
    this.dialogRef.close({
      def: this.definitionEditorData,
      keyTerm: this.keywordEditorData,
      keyTermActualData:
        this.keywordEditor.editorInstance.model.document.selection,
    });
  }

  /**
   * 'setDefinition': This function is used to populate right hand value in ckeditor pop-up.
   * @param definition : string.
   * @return : void.
   */
  public setDefinition(definition: string): void {
    this.definitionEditorString = definition
      ? this.removePropertyFromSelection(definition)
      : null;
  }

  ngOnDestroy() {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
